import React, { useEffect, useState } from 'react';
import {useParams, Link } from 'react-router-dom';
import AdOnService from '../../api/services/AdOnService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal,Button } from 'react-bootstrap'; 
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditAdOns = () => {
var imageUrl = process.env.REACT_APP_LARAVEL_ADONS_IMAGE_URL;
const params = useParams();
  const [file, setFile] = useState()
  const [error, setError] = useState([]);
  const [icon, setIcon] = useState()
  const [adOns, setAdOn] = useState([])
  const [adOnsModal, setadOnsModal] = useState(false);
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    var id = params.id;
    getAdOnByID(id);
  }, []);
  
  const getAdOnByID = async (id) => {
    try {
      let ad_on = await AdOnService.show(id).json();
      setAdOn(ad_on.data);
      setisloading(false);
    } catch (error) {
        if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var ad_ons_image = fileReader.result
      setFile(ad_ons_image)
    }
  }
const onIconChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var ad_ons_icon = fileReader.result
      setIcon(ad_ons_icon)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
          "title": event.target.title.value,
          "ad_ons_icon": icon ? icon.split(',')[1] : "",
          "ad_ons_image":file ? file.split(',')[1] : "",
          "description": event.target.description.value,
          
      }
      let responseData = await AdOnService.update(params.id,userData).json()
      if (responseData.status === true) {
        setadOnsModal(true)
      }
    } catch (error) {
        console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
      }
    
  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Ad-Ons" pageTitle={'Edit Ad-Ons'} parentTitle={'Home'} />
      <div className="container-fluid">
            <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                            <h4 className="card-title">Ad-Ons Equipments</h4>
                            </div>
                            <div className="card-body">
                                <form className="form-valide" onSubmit={onSubmitForm}>
                                <div className="row">
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Title<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" name='title' id="val-username"  
                                        defaultValue={
                                            adOns.title
                                            ?  adOns.title
                                            : ''
                                        }/>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                      <label htmlFor="val-number" className="form-label"> Ad-Ons Icon <span className="text-danger">*</span></label>
                                      {adOns.ad_ons_icon ? <img className="img-drop-area" height={100} width={100}  name="ad_ons_icon" src={icon ? icon: imageUrl+ adOns.ad_ons_icon} alt='' /> :null}
                                      <input type="file" className="form-control" name='ad_ons_icon' id="val-number"  onChange={onIconChange} />
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                      <label htmlFor="val-number" className="form-label"> Ad-Ons Image <span className="text-danger">*</span></label>
                                        {adOns.ad_ons_image ? <img className="img-drop-area" height={100} width={100}  name="ad_ons_image" src={file ? file: imageUrl+ adOns.ad_ons_image} alt='' /> :null}
                                      <input type="file" className="form-control" name='ad_ons_image' id="val-number"  onChange={onFileChange} />
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label" htmlFor="val-suggestions">Description <span className="text-danger">*</span></label>
                                        <textarea rows="3"  id="val-suggestions" className="form-control" name='description'
                                          defaultValue={
                                            adOns.description
                                            ?  adOns.description
                                            : ''
                                        }
                                        ></textarea>
                                    </div>
                                </div>
                                <h5 style={{color:'red'}}>{error}</h5>
                                <div>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
           
            </div>
        
      </div>
      {isLoading && <LogoAnimationLoader />}
        <Modal centered className="mark-attendence" show={adOnsModal}>
        <Modal.Header>
            <Modal.Title>Update </Modal.Title>
            <Button variant="" className="btn-close" onClick={() => setadOnsModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Service Successfully!!!.</Modal.Body>
        <Modal.Footer>
            <Link className="btn btn-primary" to={'/admin/ad_ons_equipments'} variant="danger light" onClick={() => setadOnsModal(false)}>Close</Link>
        </Modal.Footer>
        </Modal>
    </>
  );
};
export default EditAdOns;